export const is_symbols_includes_more_than_n = (str: string) => {
    const newlineArray = str.split('\n');
    return newlineArray.length > 5;
}
